export const WEATHER_COLORS = [
  "#3f51b5",
  "#2196f3",
  "#00bcd4",
  "#4caf50",
  "#ffeb3b",
  "#ff9800",
  "#f44336",
];

/** Maps a speed within [minSpeed, maxSpeed] onto the weather-style color gradient. */
export function speedToWeatherColor(speed: number, minSpeed: number, maxSpeed: number) {
  if (maxSpeed <= minSpeed) return WEATHER_COLORS[Math.floor(WEATHER_COLORS.length / 2)];

  const ratio = (speed - minSpeed) / (maxSpeed - minSpeed);
  const clamped = Math.min(1, Math.max(0, ratio));
  const colorIndex = Math.round(clamped * (WEATHER_COLORS.length - 1));
  return WEATHER_COLORS[colorIndex];
}
